import { Ability } from "@casl/ability"
import { initialAbility } from "./initialAbility"

export default new Ability(initialAbility)
